import { cx } from '@/lib/cx'

/** The look of a text control, without a size: `Field`'s controls and any bare `<input>` outside one. */
export const controlClass = cx(
  'rounded-lg border border-border bg-surface px-3 text-base text-fg',
  'placeholder:text-muted focus:border-accent-ink focus:outline-none focus:ring-2 focus:ring-accent',
  'aria-invalid:border-danger aria-invalid:ring-danger disabled:opacity-50',
)
